import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { displayErrorMessage, displayKudzuplusErrorMessage, ValidationIcon } from '../../../utils';
import { appTheme } from '../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../Redux/selectors';
import { BorderStyles } from 'utils/constants';
import FieldLabel from "../../CustomComponents/FieldLabel";


const CustomTextInput = (props) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
    const appThemeData = appTheme(kudzuPlusTrue)
    const { t } = useTranslation(); // Hook to access translation functions
    const [isFocused, setIsFocused] = useState(false);
    const errorElId = `${props.name}-field-error`; // Unique ID for error message element`;
   
    return (
        <div className='w-full'>          
            <FieldLabel
                name={props?.name}
                label={props?.label || props?.name}
                textColor={props?.textColor}
                labelColor={props?.labelColor}
                required={props?.required || false}
            />         

            <div className='flex flex-row w-full items-center'>
                <input
                  onKeyDown={(e) => {
                        // Prevent spaces if disallowSpaces prop is true
                        if (props?.disallowSpaces && (e.key === ' ' || e.keyCode === 32)) {
                            e.preventDefault();
                        }
                        // Allow only numbers if numbersOnly prop is true
                        if (props?.numbersOnly) {
                            // Allow backspace and delete for editing
                            if (e.key === 'Backspace' || e.key === 'Delete') {
                                return; // Allow these keys
                            }
                            // Allow only numbers (0-9)
                            if (!/^[0-9]$/.test(e.key)) {
                                e.preventDefault();
                            }
                        }
                        props?.onKeyDown?.(e);
                    }}
                    className={`placeholder:font-semibold font-hanken-grotesk text-16 md:font-[500] sm:font-[700] font-[500]
                        ${isTransferMoneyFeatureEnabled ? 'placeholder:text-[#767673]' : ''}
                        ${BorderStyles(props?.error , kudzuPlusTrue)}                             
                        ${props?.inputWidth ? props?.inputWidth : 'md:w-[288px] sm:w-[200px] w-full'} 
                      pl-8 `}
                    id={props?.name}
                    name={props?.name}
                    type={props?.type || 'text'}
                    placeholder={props?.placeholder}
                    required={props?.required || false}
                    value={props?.value || ''}
                    maxLength={props?.maxLength || undefined}
                    autoFocus={props?.autoFocus || false}
                    onChange={(e) => { props?.onChange?.(e) }}
                    onBlur={(e) => { setIsFocused(false); props?.onBlur?.(e) }}
                    onFocus={(e) => { setIsFocused(true); props?.onFocus?.(e) }}
                    autoComplete="off"
                    aria-autocomplete="none"
                    aria-describedby={props?.error ? errorElId : ""}
                    style={{
                        color: isTransferMoneyFeatureEnabled ? 'var(--input-text-value)' : 'var(--input-text)',
                        backgroundColor: 'var(--input-bg)',
                        height: props?.height || '60px',
                        outline: 'none',
                        // fontWeight: '500',
                        '::placeholder': {
                            color: 'var(--input-text)', // Placeholder color         
                        },

                        ...props.style, // Allow additional custom styles from parent component
                    }}
                    readOnly={props?.readOnly || false}
                />
                {props?.showValidity && (
                    <div className='ml-2'>
                        <ValidationIcon
                            isFocused={isFocused}
                            isValid={props?.isValid}
                            inputValueLen={(props?.value || '').length}
                            appThemeData={appThemeData}
                            message={props?.error}
                        />
                    </div>
                )}
            </div>

            {props?.error && props?.error.length > 0 && <div className=' w-full' id={errorElId}>
                {/* {props?.error && displayErrorMessage(props?.error)} */}

                { (kudzuPlusTrue ? displayKudzuplusErrorMessage(props?.error) : displayErrorMessage(props?.error))}
            </div>
            }

        </div>

    );
};

export default CustomTextInput;